const negativeInfinity = {
    negativeInfinity: {
        test (x) { return x === Number.NEGATIVE_INFINITY; },
        replace (n) { return '-Infinity'; },
        revive (s) { return Number.NEGATIVE_INFINITY; }
    }
};

export default negativeInfinity;
